
import Breadcrumbs from '~/components/UI/Breadcrumbs';
import FilterCatalog from '~/components/catalog/Filter';
import SetsMixin from '~/node_modules/sitis-nuxt/lib/mixins/SetsMixin.ts';
import {
  AppMixin,
} from '~/node_modules/sitis-nuxt/lib/mixins';

const timeOutStartUpdateFilter = null;
export default {
  name: 'Slug',

  head: function () {
    const title = this.filterInfo?.filterPages?.[0]?.seo_title || this.filterInfo?.seo_title || this.category?.seo?.title || this.category?.metaTitle || this.category?.title;
    const description = this.filterInfo?.filterPages?.[0]?.seo_description || this.filterInfo?.seo_description || this.category?.seo?.description || this.category?.metaDescription || '';

    return this.$seoMetaHelper({
      title: title,
      description: description,

      meta: this.headMeta,
      // link: this.headLink,
    });
  },

  data: function () {
    return {
      productsRecentlyViewed: [],
      currentFilterSelected: { ...this.selectedFilters },

      isUpdateLocalFilterFull: false,
    };
  },

  mixins: [
    AppMixin,
    SetsMixin,
  ],

  computed: {
    // Данные на стрсницке
    breadcrumbs: function () {
      console.log('asdasD:', this.category);
      return [
        { title: 'Главная', path: '/' },
        { title: 'Каталог', path: '/catalog' },
        { title: this.category?.title, path: this.category?.url },
      ];
    },
    titleH1: function () {
      return this.filterInfo?.filterPages?.[0]?.title || this.filterInfo?.h1 || this.category?.title || this.category?.name;
    },
    isLoadingProducts: function () {
      return Boolean(
        this.$store.state?.appState?.loading?.category
        || this.$store.state?.appState?.loading?.products
        || this.$store.state?.loading?.updateProducts,
      );
    },
    valueSelectedTransport: function () {
      if (!this.selectedFilters?.car || true) {
        return;
      }
      return ((this.filters || [])
        .find((t) => t.slug === 'car')?.variants || [])
        .find((t) => t.slug === Object.keys(this.selectedFilters?.car || {})?.[0])?.label;
    },
    categoryDescription: function () {
      if (this.pagination?.page > 1) {
        return '';
      }
      return this.category?.dynamicFields?.bottom_text || this.category?.description || '';
    },
    sortOptions: function () {
      return [
        { id: 'default', type: 'string', value: 'По умолчанию' },
        { id: 'price', type: 'string', value: 'Дешевле' },
        { id: '-price', type: 'string', value: 'Дороже' },
      ];
    },
    showCarFilterSlug: function () {
      if (!this.category?.dynamicFields?.show_car_filter) {
        return '';
      }
      return this.category?.dynamicFields?.characteristicGroup?.slug || '';
    },
    headMeta: function () {
      const title = this.filterInfo?.filterPages?.[0]?.seo_title || this.filterInfo?.seo_title || this.category?.seo?.title || this.category?.metaTitle || this.category?.title;
      const description = this.filterInfo?.filterPages?.[0]?.seo_description || this.filterInfo?.seo_description || this.category?.seo?.description || this.category?.metaDescription || '';
      const currentFilterString = (this.$route?.path || '').split('/f/').pop();
      const canonical = this.category?.seo?.canonical;
      const isActiveSearchFilter = Boolean(currentFilterString);
      const isNotProducts = Boolean(isActiveSearchFilter && this.products.length <= 0);

      const list = [
        {
          name: 'og:title', hid: 'og:title', property: 'og:title', content: title,
        },
        { name: 'description', hid: 'metadescription', content: description },
        {
          name: 'og:description', hid: 'og:description', property: 'og:description', content: description,
        },
      ];
      if (
        Boolean(currentFilterString.indexOf(',') > -1 || currentFilterString.indexOf('zabrat-sejchas') > -1)
          || Boolean(isNotProducts)
      ) {
        list.push({ name: 'robots', content: 'noindex' });
      }

      return list;
    },
    headLink: function () {
      const host = `https://${this.$store.state?.['local-settings']?.headers?.host}/`;
      const fullPath = (this.$route?.fullPath || '').substring(1);
      const urlCanonical = [host, fullPath]
        .filter((t) => !!t)
        .join('')
        .split('?')?.[0];

      const list = [
        { rel: 'canonical', href: urlCanonical },
      ];
      return list;
    },
    isUpdateProducts: function () {
      return this.$store.state?.loading?.updateProducts;
    },
    sparkSlug: function () {
      if (this.category?.dynamicFields?.characteristic_group_id === 2) {
        return 'tiporazmer';
      }
      if (this.category?.dynamicFields?.characteristic_group_id === 3) {
        return 'disksize';
      }
      return false;
    },

    // Данные по CMS контнеты
    cmsPageIdTop: function () {
      const pageId = this.filterInfo?.filterPages?.[0]?.cms_page_id;
      if (!pageId) {
        return null;
      }
      return Number.parseFloat(pageId);
    },
    cmsPageIdBottom: function () {
      return this.category?.dynamicFields?.after_cms_page_id || this.vars?.['CMS PAGE ID для каталога (под сеткой товаров)'] || '';
    },

    // Даннаые для получения товаров
    extensions: function () {
      return ['short_characteristics', 'characteristicGroup'];
    },
    extensionsCategory: function () {
      return ['characteristicGroup'];
    },
    isCustomMounted: function () {
      return true;
    },
    canceledOptions: function () {
      return {
        categories_depth: true,
        categories_active: true,
      };
    },

  },

  components: {
    Breadcrumbs,
    FilterCatalog,

    Sort: () => import('~/components/catalog/Sort'),
    ProductCard: () => import('~/components/catalog/ProductCard'),
    ProductCardLoading: () => import('~/components/catalog/ProductCardLoading'),
    SelectedTransport: () => import('~/components/catalog/SelectedTransport'),
    PopUpSelectTransport: () => import('~/components/catalog/PopUpSelectTransport'),
    Pagination: () => import('~/components/UI/Pagination'),
    BlockNotFound: () => import('~/components/catalog/BlockNotFound'),
  },

  mounted: async function () {
    await this.replaceOrlUrls();
    await this.loadFilter();
    await this.getProductsRecentlyViewed();
  },

  methods: {
    changeFilterType: function () {
      this.$refs.refFilterCatalog.changeSelectionCarValue(true);
    },
    eventChangePage: function (newPage) {
      this.$store.commit('products/setProducts', []);

      this.onChangePageWithoutFilters(newPage);

      const topProductsList = this.$refs.contentProductList.getBoundingClientRect().top;
      const headerHeight = document.getElementsByClassName('header')?.[0]?.getBoundingClientRect()?.height;

      window.scrollTo({
        top: topProductsList + window.pageYOffset - headerHeight - 20,
        left: 0,
        behavior: 'auto',
      });
    },

    getProductsRecentlyViewed: async function () {
      const products = await this.$api.agent.transport.get('/recently-viewed').then((res) => res.data).catch(() => []);
      this.productsRecentlyViewed = products;
    },

    getUpdateProducts: async function (filter) {
      clearTimeout(timeOutStartUpdateFilter);
      this.$store.commit('loading/setLoadingKey', {
        key: 'updateProducts',
        value: true,
      });
      await this.updateProductsWithoutFilters(filter);
      this.$store.commit('loading/setLoadingKey', {
        key: 'updateProducts',
        value: false,
      });
    },
    getUpdateFilters: async function (filter) {
      // Сбор фильтр для бекенда
      const updateFiltersRequest = [];
      Object.keys(filter || {}).map((variantSlug) => {
        const values = [];

        Object.keys(filter[variantSlug]).map((value) => {
          values.push(value);
        });

        if (variantSlug === 'categories') {
          const valueIds = this._getCategoryIdsFromSlugs(values);
          valueIds.map((value) => {
            updateFiltersRequest.push({
              name: variantSlug,
              values: [value],
            });
          });
        } else {
          updateFiltersRequest.push({
            name: variantSlug,
            values: values,
          });
        }
      });

      // Получение активных фильтров
      this.$store.commit('loading/setLoadingKey', {
        key: 'updateFilters',
        value: true,
      });
      await this.getFilters({
        slug: this.category?.slug,
        slugs: [],
        filters: updateFiltersRequest,
        isHideLoad: true,
        canceledOptions: this.canceledOptions,
      });
      await this.getFilterPagesWithoutFilters();
      // await this.getFilterPagesWithoutFilters();
      this.$store.commit('loading/setLoadingKey', {
        key: 'updateFilters',
        value: false,
      });
    },
    getUpdateFilterFull: async function () {
      if (JSON.stringify(this.currentFilterSelected) === JSON.stringify(this.selectedFilters)) {
        return;
      }
      await this.getUpdateFilters(this.selectedFilters);
      this.currentFilterSelected = { ...this.selectedFilters };
    },
    getUpdateLocalFilterFull: async function () {
      if (JSON.stringify(this.currentFilterSelected) === JSON.stringify(this.selectedFilters)) {
        return;
      }
      this.isUpdateLocalFilterFull = true;
      await this.getUpdateFilters(this.selectedFilters);
      this.currentFilterSelected = { ...this.selectedFilters };
      this.isUpdateLocalFilterFull = false;
    },

    replaceOrlUrls: function () {
      const newSelectedFilters = [];
      const newSearch = [];

      const query = this.$route?.query || {};
      if (Object.keys(query).length <= 0) {
        return;
      }

      const replaceVariantValues = {
        'season.0': 'zima',
        'season.1': 'leto',
      };
      Object.keys(query).map((searchKey) => {
        if (searchKey === 'page' || searchKey === 'sort') {
          newSearch.push(`${searchKey}=${query[searchKey]}`);
        } else {
          let value = query[searchKey];
          if (replaceVariantValues[`${searchKey}.${value}`]) {
            value = replaceVariantValues[`${searchKey}.${value}`];
          }
          newSelectedFilters.push(`${searchKey}=${value}`);
        }
      });
      if (newSelectedFilters.length <= 0) {
        return;
      }

      let newUrl = this.$route.path;
      if (newSelectedFilters.length > 0) {
        newUrl = `${newUrl}/f/${newSelectedFilters.join('/')}`;
      }
      if (newSearch.length > 0) {
        newUrl = `${newUrl}?${newSearch.join('&')}`;
      }

      window.location.href = newUrl;
    },
  },
};
